
'use client';
import dynamic from 'next/dynamic';
import { Skeleton } from '../ui/skeleton';

const HeroClient = dynamic(() => import('./hero-client').then(mod => mod.HeroClient), {
  ssr: false,
  loading: () => <Skeleton className="w-full md:w-1/2 h-[50vh] md:h-screen" />
});

export function Hero() {
  return <HeroClient />;
}
